import { configureStore } from '@reduxjs/toolkit'

import personReducer from './pages/form/sections/personSlice'
import corporationReducer from './pages/form/sections/corporationSlice'
import fundingReducer from './pages/form/sections/fundingSlice'
import notaryReducer from './pages/form/sections/notarySlice'
import termsReducer from './pages/form/sections/termsSlice'

export const store = configureStore({
	reducer: {
		person: personReducer,
		corporation: corporationReducer,
		funding: fundingReducer,
		notary: notaryReducer,
		terms: termsReducer,
	},
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
